import styles from './successModal.module.scss';
import Image from 'next/image';

interface SuccessModalProps {
  onClose?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={handleContentClick}>
        <button className={styles.closeButton} onClick={onClose}>
          <Image
            src="/img/modal/close.svg"
            alt="Close"
            width={24}
            height={24}
          />
        </button>
        <div className={styles.logoContainer}>
          <Image
            src="/img/modal/success-logo.webp"
            alt="Hera Flight"
            width={136}
            height={108}
          />
        </div>
        <h2 className={styles.title}>Thank you!</h2>
        <p className={styles.message}>
          Your message has been sent successfully. We&apos;ll get back to you
          shortly.
        </p>
      </div>
    </div>
  );
};

export default SuccessModal;
